/* eslint-disable no-undef */
/* eslint-disable no-sequences */
/* eslint-disable no-unused-expressions */
import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import Swal from 'sweetalert2'
import api from '../service/service.js'
import addcustomer from '../components/modal/addcustomer'
import DatePicker from 'vue2-datepicker'
export default {
  name: 'member',
  data () {
    return {
      time1: '',
      time2: '',
      time3: '',
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      shortcuts: [
        {
          text: 'Today',
          onClick: () => {
            this.time3 = [ new Date(), new Date() ]
          }
        }
      ],
      timePickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '23:30'
      },
      family_id: 0,
      address_number: '',
      moo_name: 'แม่ขี้มูก',
      moo_number: '5',
      district: 'บ้านทับ',
      amphoe: 'แม่แจ่ม',
      province: 'เชียงใหม่',
      zipcode: '50270',
      memberAll: [],
      prefix: [],
      gender: [],
      ModalMember: false,
      send_member_id: 0,
      send_family_id: 0,
      send_prefix_id: '',
      send_gender_id: '',
      send_fname: '',
      send_lname: '',
      send_id_card: '',
      send_age: '',
      send_nationality: '',
      send_race: '',
      send_brithday: '',
      send_occupation: '',
      member_data: [
        // {
        //   family_id: '',
        //   prefix_id: 1,
        //   fname: 'test',
        //   lname: 'tsetmember',
        //   id_card: '150000150319',
        //   age: '50',
        //   gender_id: 1,
        //   nationality: 'ไทย',
        //   race: 'ไทย',
        //   brithday: '2019-05-29',
        //   occupation: 'ชาวนา'
        // }
      ],
      memberNew: {
        prefix_id: 1,
        fname: '',
        lname: '',
        id_card: '',
        age: '',
        gender_id: 1,
        nationality: '',
        race: '',
        brithday: '',
        occupation: ''
      }
    }
  },
  components: {
    ThailandAutoComplete,
    addcustomer,
    DatePicker
  },
  methods: {
    select (address) {
      this.district = address.district
      this.amphoe = address.amphoe
      this.province = address.province
      this.zipcode = address.zipcode
    },
    EditFamily () {
      Swal.fire({
        title: 'ยืนยันการแก้ไขข้อมูล?',
        text: 'เมื่อยืนยันระบบจะแก้ไขข้อมูลนี้!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(result => {
        if (result.value) {
          let payload = {
            family_id: this.family_id,
            address_number: this.address_number,
            moo_name: this.moo_name,
            moo_number: this.moo_number,
            tambon: this.district,
            district: this.amphoe,
            province: this.province
          }
          api.familyEdit(
            payload,
            result => {
              console.log(this.result)
              if (result.result === true) {
                this.alert_msg(
                  'success',
                  'ข้อความจากระบบ',
                  'บันทึกสำเร็จ '
                )
              }
            },
            calback => {
              console.log(calback)
            })
        }
      })
    },
    familyById () {
      let payload = this.family_id
      console.log('familyById:', payload)
      api.familyById(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            this.family_id = result.data[0].family_id,
            this.address_number = result.data[0].address_number,
            this.moo_name = result.data[0].moo_name,
            this.moo_number = result.data[0].moo_number,
            this.district = result.data[0].tambon,
            this.amphoe = result.data[0].district,
            this.province = result.data[0].province
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    back () {
      this.$router.push({name: 'family_lis'})
    },
    memberShow () {
      let payload = this.family_id
      console.log('memberShow:', this.family_id)
      api.memberShow(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            console.log(result.data)
            for (var i = 0; i < result.data.length; i++) {
              this.memberAll.push(result.data[i])
            }
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    memberDelete (val) {
      console.log('member_id:', val.member_id)
      Swal.fire({
        title: 'ยืนยันการอนุมัติ?',
        text: 'เมื่อยืนยันระบบจะทำการอนุมัติบิลนี้!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(result => {
        if (result.value) {
          let payload = val.member_id
          api.memberDelete(
            payload,
            result => {
              console.log(result)
              if (result.result === true) {
                this.alert_msg(
                  'success',
                  'ข้อความจากระบบ',
                  'บันทึกสำเร็จ '
                )
              }
              this.familyById()
              this.memberShow()
              // location.reload()
            },
            error => {
              alert(error)
              console.log(error)
            })
        }
      })
    },
    // editMember (val) {
    //   console.log('tag_member_id', val.member_id)
    //   this.send_member_id = val.member_id
    //   $('#Modal').modal('show')
    // },
    editMember (val) {
      console.log('tag_member_id', val.prefix_id)
      // this.memberNew.prefix_id = val.member_data.member_id
      // this.memberNew.family_id = val.member_data.family_id
      this.memberNew.prefix_id = val.prefix_id
      this.memberNew.gender_id = val.gender_id
      this.memberNew.fname = val.fname
      this.memberNew.lname = val.lname
      this.memberNew.id_card = val.id_card
      this.memberNew.age = val.age
      this.memberNew.nationality = val.nationality
      this.memberNew.race = val.race
      this.memberNew.brithday = val.brithday
      this.memberNew.occupation = val.occupation
      $('#ModalAdd').modal('show')
    },
    addMember () {
      console.log('family_id', this.family_id)
      this.send_member_id = 0
      this.send_family_id = this.family_id
      this.send_prefix_id = ''
      this.send_gender_id = ''
      this.send_fname = ''
      this.send_lname = ''
      this.send_id_card = ''
      this.send_age = ''
      this.send_nationality = ''
      this.send_race = ''
      this.send_brithday = ''
      this.send_occupation = ''
      console.log('tag_member_id', this.send_member_id)
      $('#Modal').modal('show')
    },
    GetGen (val) {
      console.log(val)
      if (val === '1') {
        return 'ชาย'
      } else {
        return 'หญิง'
      }
    },
    GetPrefix (val) {
      console.log(val)
      if (val === 1) {
        return 'นาย'
      }
      if (val === 2) {
        return 'นาง'
      }
      if (val === 3) {
        return 'นางสาว'
      }
    },
    confirm () {
      if (this.address_number === '' || this.moo_name === '' || this.moo_number === '' || this.district === '' || this.amphoe === '' || this.province === '' || this.zipcode === '') {
        Swal.fire({
          title: 'กรุณากรอกข้อมูลให้ครบ?',
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Yes'
        })
      } else {
        console.log('family_id', this.family_id)
        if (this.family_id === 0) {
          console.log('family_id', this.family_id)
          this.AddFamily()
        } else {
          console.log('family_id', this.family_id)
          this.EditFamily()
        }
      }
    },
    AddFamily () {
      Swal.fire({
        title: 'ยืนยันการอนุมัติ?',
        text: 'เมื่อยืนยันระบบจะทำการอนุมัติบิลนี้!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(result => {
        if (result.value) {
          let payload = {
            address_number: this.address_number,
            moo_name: this.moo_name,
            moo_number: this.moo_number,
            tambon: this.district,
            district: this.amphoe,
            province: this.province,
            zipcode: this.zipcode
          }
          api.familyAdd(
            payload,
            result => {
              console.log(result)
              if (result.result === true) {
                this.alert_msg(
                  'success',
                  'ข้อความจากระบบ',
                  'บันทึกสำเร็จ '
                )
                this.family_id = result.data.family_id
                console.log('family_idRes', this.family_id)
                this.addLoopMember()
                this.familyById()
                this.memberShow()
                // Swal.fire({
                //   title: 'ต้องการเพิ่มสมาชิกครอบครัวหรือไม่?',
                //   type: 'warning',
                //   showCancelButton: true,
                //   confirmButtonColor: '#3085d6',
                //   cancelButtonColor: '#d33',
                //   confirmButtonText: 'ตกลง'
                // }).then(result => {
                //   if (result.value) {
                //     this.$router.push({ name: 'edit_family', params: { id: this.family_id } })
                //   }
                // })
              }
            },
            calback => {
              console.log(calback)
            })
        }
      })
    },
    setter () {
      this.family_id = 0
    },
    addData () {
      $('#ModalAdd').modal('show')
    },
    pushData () {
      member_data[i]
    },
    setDone: function (e) {
      if (this.memberNew.prefix_id === '' || this.memberNew.fname === '' || this.memberNew.lname === '' ||
      this.memberNew.id_card === '' || this.memberNew.age === '' ||
      this.memberNew.gender_id === '' || this.memberNew.nationality === '' || this.memberNew.race === '' ||
      this.memberNew.brithday === '' || this.memberNew.occupation === '') {
        Swal.fire(
          'ข้อความจากระบบ',
          'กรุณากรอกข้อมูลให้ครบถ้วน',
          'warning'
        )
        return
      }
      $('#ModalAdd').modal('hide')
      this.member_data.push({
        prefix_id: this.memberNew.prefix_id,
        fname: this.memberNew.fname,
        lname: this.memberNew.lname,
        id_card: this.memberNew.id_card,
        age: this.memberNew.age,
        gender_id: this.memberNew.gender_id,
        nationality: this.memberNew.nationality,
        race: this.memberNew.race,
        brithday: this.memberNew.brithday,
        occupation: this.memberNew.occupation
      })
      e.preventDefault()
    },
    deleteMember (val) {
      this.member_data.splice(this.member_data.indexOf(val), 1)
    },
    getgender () {
      api.gender(
        result => {
          console.log(result)
          if (result.result === true) {
            this.gender = result.data
          }
        },
        calback => {
          console.log(calback)
        })
    },
    getprefix () {
      api.prefix(
        result => {
          console.log(result)
          if (result.result === true) {
            this.prefix = result.data
            console.log(this.prefix)
          }
        },
        calback => {
          console.log(calback)
        })
    },
    addLoopMember () {
      console.log('tag', this.member_data.length)
      for (var i = parseInt(this.member_data.length - 1); i >= 0; i--) {
        let payload = {
          family_id: this.family_id,
          prefix_id: this.member_data[i].prefix_id,
          fname: this.member_data[i].fname,
          lname: this.member_data[i].lname,
          id_card: this.member_data[i].id_card,
          age: this.member_data[i].age,
          gender_id: this.member_data[i].gender_id,
          nationality: this.member_data[i].nationality,
          race: this.member_data[i].race,
          brithday: this.member_data[i].brithday,
          occupation: this.member_data[i].occupation
        }
        console.log(payload)
        api.memberAdd(
          payload,
          result => {
            console.log(result)
            if (result.result === true) {
              $('#Modal').modal('hide')
            }
          },
          error => {
            alert(error)
            console.log(error)
          })
      }
      if (i < 0) {
        setTimeout(this.$router.push({ name: 'edit_family', params: { id: this.family_id } }), 1500)
      }
    },
    test () {
      console.log('tag', this.family_id)
    }
  },
  mounted () {
    this.getgender()
    this.getprefix()
    if (this.$route.params.id) {
      this.family_id = this.$route.params.id
      this.familyById()
      this.memberShow()
    } else {
      this.setter()
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/add_family.js